import React from 'react'
import Home from '../feature/Home/Home'

const HomePage = () => {
  return <Home/>
}

export default HomePage